// YadsRecurringScheduleAction.js
import {
  POST_YADS_RECURRING_REQUEST,
  POST_YADS_RECURRING_SUCCESS,
  POST_YADS_RECURRING_FAILURE,
  POST_YADS_RECURRING_RESET,
} from '../../../Constants/actionTypes';

import { postYadsRecurringScheduleIngestion } from '../../../Constants/apiService';

export const postYadsRecurringRequest = () => ({ type: POST_YADS_RECURRING_REQUEST });
export const postYadsRecurringSuccess = (data) => ({ type: POST_YADS_RECURRING_SUCCESS, payload: data });
export const postYadsRecurringFailure = (err)  => ({ type: POST_YADS_RECURRING_FAILURE, payload: err });
export const postYadsRecurringReset   = ()    => ({ type: POST_YADS_RECURRING_RESET });

export const startYadsRecurringScheduleIngestion = (payload) => {
  return async (dispatch, getState) => {
    dispatch(postYadsRecurringRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await postYadsRecurringScheduleIngestion(payload, accessToken);
      dispatch(postYadsRecurringSuccess(res));
    } catch (error) {
      const msg = error?.response?.data?.message ||
                  error?.response?.data?.error   ||
                  (error.message?.includes("fetch")
                    ? "Unable to create recurring schedule. Please try again."
                    : error.message) ||
                  "Recurring schedule failed";
      dispatch(postYadsRecurringFailure(msg));
    }
  };
};
